import { ProductAttributeGroupType } from "./ProductAttributeGroupType.js";

export const productAttributeGroupTypeToStructuredDataVariesByMap: Record<ProductAttributeGroupType, string> = {
	[ProductAttributeGroupType.Color]: "https://schema.org/color",
};
